import styled from 'styled-components'
import { pxToRem } from '../../styles/utils'
import { withAlpha } from "styles/utils";

export const VideoPlayerContainer = styled.div`
  flex: 0 0 100%;
  width: 100%;
  max-width: 100%;
  min-height: ${pxToRem(400)};
  height: ${pxToRem(400)};
  background: ${({ theme }) => theme.colors.blackHex};
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
`

export const VideoWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: ${pxToRem(400)};
  overflow: hidden;

  video {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    min-height: ${pxToRem(400)};
    object-fit: contain;
    background: ${({ theme }) => theme.colors.blackHex};
    margin: 0;
    padding: 0;
  }
`

export const VideoTitle = styled.div<{ $show: boolean }>`
  position: absolute;
  top: ${pxToRem(12)};
  left: ${pxToRem(12)};
  right: ${pxToRem(12)};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  background: linear-gradient(to bottom, ${({ theme }) => theme.colors.shadowHeavy}, ${({ theme }) => withAlpha(theme.colors.black, 0)});
  color: ${({ theme }) => theme.colors.whiteHex};
  font-size: ${pxToRem(14)};
  font-weight: 500;
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)} ${pxToRem(8)} 0 0;
  z-index: 10;
  pointer-events: none;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  transition: opacity 0.3s ease;
`

export const QualityButton = styled.button`
  position: absolute;
  bottom: ${pxToRem(60)};
  right: ${pxToRem(12)};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  background: ${({ theme }) => withAlpha(theme.colors.black, 0.7)};
  color: ${({ theme }) => theme.colors.whiteHex};
  border: 1px solid ${({ theme }) => withAlpha(theme.colors.white, 0.3)};
  border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
  font-size: ${pxToRem(12)};
  font-weight: 500;
  cursor: pointer;
  z-index: 15;
  transition: background 0.2s ease;
  min-width: ${pxToRem(60)};

  &:hover {
    background: ${({ theme }) => withAlpha(theme.colors.black, 0.9)};
    border-color: ${({ theme }) => withAlpha(theme.colors.white, 0.5)};
  }

  &:active {
    background: ${({ theme }) => withAlpha(theme.colors.black, 1)};
  }
`

export const QualityMenu = styled.div`
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-bottom: ${pxToRem(4)};
  background: ${({ theme }) => withAlpha(theme.colors.black, 0.95)};
  border: 1px solid ${({ theme }) => withAlpha(theme.colors.white, 0.3)};
  border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
  min-width: ${pxToRem(100)};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows.lg};
`

export const QualityMenuItem = styled.div<{ $active: boolean }>`
  padding: ${pxToRem(8)} ${pxToRem(16)};
  color: ${({ theme }) => theme.colors.whiteHex};
  font-size: ${pxToRem(12)};
  cursor: pointer;
  background: ${({ $active }) => ($active ? '${({ theme }) => withAlpha(theme.colors.white, 0.2)}' : 'transparent')};
  transition: background 0.2s ease;

  &:hover {
    background: ${({ theme }) => withAlpha(theme.colors.white, 0.15)};
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => withAlpha(theme.colors.white, 0.1)};
  }
`
